import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdmin } from './AdminContext';
import './css/admin-global.css';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAdmin();

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="admin-spinner" />
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
